export default {
  backForward: 'Back',
  application: 'Application',
  baseInfo: 'BaseInfo',
  basicInformation: "基础信息",
  voucherAndBasicInformation: "凭证与基础信息",
  membersManage: 'Members',
  applicationCapability: "应用能力",
  addAppCapabilities: "添加应用功能",
  applicationWe: "We码",
  applicationLight: "轻应用",
  applicationRobot: "机器人",
  developmentConfiguration: "开发配置",
  permissionManagement: "权限管理",
  eventsAndCallbacks: "事件与回调",
  securitySettings: "安全设置",
  applicationRelease: "应用发布",
  versionManagementAndRelease: "版本管理与发布",
  operationAndMonitoring: "运营与监控",
  logRetrieval: "日志检索",
  editionManage: 'Edition',
  powerManage: '权限申请',
  apiManage: 'Interfaces',
  securitySet: 'SecuritySet',
  versionManageRelease: 'VersionManageRelease'
};
